define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ContactPerson = (function () {
        function ContactPerson() {
            this.FirstName = null;
            this.LastName = null;
            this.MiddleName = null;
            this.MailAddress = null;
            this.Phone = null;
            this.Mobile = null;
            this.Fax = null;
            this.Department = null;
        }
        return ContactPerson;
    }());
    exports.ContactPerson = ContactPerson;
});
//# sourceMappingURL=ContactPerson.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/ContactPerson.js
// module id = 108
// module chunks = 0